function addAttrToEl(doc, el, name, value) {
    let attr = doc.createAttribute(name);
    attr.value = value;
    el.setAttributeNode(attr);
}

export function GenerateSVG(grid, rects, guides, margins, centerLines) {
    let doc = document.implementation.createDocument(null,null,null);
    let svg = doc.createElementNS('http://www.w3.org/2000/svg','svg');

    addAttrToEl(doc, svg, 'id', grid.name);
    addAttrToEl(doc, svg, 'version', 1.0);
    addAttrToEl(doc, svg, 'viewBox', `0 0 ${grid.width} ${grid.height}`);
    addAttrToEl(doc, svg, 'width', `${grid.width}`);
    addAttrToEl(doc, svg, 'height', `${grid.height}`);

    let svgGrid = doc.createElementNS('http://www.w3.org/2000/svg','g');
    addAttrToEl(doc, svgGrid, 'id', 'SVG-Grid');
    addAttrToEl(doc, svgGrid, 'inkscape:label', 'SVG-Grid');
    addAttrToEl(doc, svgGrid, 'inkscape:groupmode', 'layer');

    if (grid.showRects) {
        let rectGroup = doc.createElementNS('http://www.w3.org/2000/svg','g');
        addAttrToEl(doc, rectGroup, 'id', 'Rectangles');
        addAttrToEl(doc, rectGroup, 'inkscape:label', 'Rectangles');
        addAttrToEl(doc, rectGroup, 'inkscape:groupmode', 'layer');

        rects.map(function (rect) {
            let rectEl = doc.createElementNS('http://www.w3.org/2000/svg','rect');
            addAttrToEl(doc,rectEl,'x', rect.x);
            addAttrToEl(doc,rectEl,'y', rect.y);
            addAttrToEl(doc,rectEl,'width', rect.width);
            addAttrToEl(doc,rectEl,'height', rect.height);
            addAttrToEl(doc,rectEl,'style', `fill:${rect.fillColor};fill-opacity:${rect.fillOpacity};`);
            rectGroup.appendChild(rectEl);
        });

        svgGrid.appendChild(rectGroup);
    }

    if (grid.showGuides) {
        let guideGroup = doc.createElementNS('http://www.w3.org/2000/svg','g');
        addAttrToEl(doc, guideGroup, 'id', 'Guides');
        addAttrToEl(doc, guideGroup, 'inkscape:label', 'Guides');
        addAttrToEl(doc, guideGroup, 'inkscape:groupmode', 'layer');

        guides.map(function(guide){
            let guideEl = doc.createElementNS('http://www.w3.org/2000/svg','line');
            addAttrToEl(doc, guideEl, 'x1', guide.vertical ? guide.position : 0);
            addAttrToEl(doc, guideEl, 'x2', guide.vertical ? guide.position : grid.width);
            addAttrToEl(doc, guideEl, 'y1', guide.vertical ? 0 : guide.position);
            addAttrToEl(doc, guideEl, 'y2', guide.vertical ? grid.height : guide.position);
            addAttrToEl(doc, guideEl, 'style', `stroke:${guide.color};stroke-opacity:${guide.opacity};stroke-width:1`); 
            guideGroup.appendChild(guideEl);
        });

        svgGrid.appendChild(guideGroup);
    }

    if (grid.showMargins) {
        let marginGroup = doc.createElementNS('http://www.w3.org/2000/svg','g');
        addAttrToEl(doc, marginGroup, 'id', 'Margins');
        addAttrToEl(doc, marginGroup, 'inkscape:label', 'Margins');
        addAttrToEl(doc, marginGroup, 'inkscape:groupmode', 'layer');

        margins.map(function(margin){
            let marginEl = doc.createElementNS('http://www.w3.org/2000/svg','line');
            addAttrToEl(doc, marginEl, 'x1', margin.vertical ? margin.position : 0);
            addAttrToEl(doc, marginEl, 'x2', margin.vertical ? margin.position : margin.width);
            addAttrToEl(doc, marginEl, 'y1', margin.vertical ? 0 : margin.position);
            addAttrToEl(doc, marginEl, 'y2', margin.vertical ? margin.height : margin.position);
            addAttrToEl(doc, marginEl, 'style', `stroke:${margin.color};stroke-opacity:${margin.opacity};stroke-width:1`); 
            marginGroup.appendChild(marginEl);
        });

        svgGrid.appendChild(marginGroup);
    }

    if (grid.showHcenter || grid.showVcenter){
        let centerGroup = doc.createElementNS('http://www.w3.org/2000/svg','g');
        addAttrToEl(doc, centerGroup, 'id', 'Center Lines');
        addAttrToEl(doc, centerGroup, 'inkscape:label', 'Center Lines');
        addAttrToEl(doc, centerGroup, 'inkscape:groupmode', 'layer');

        if (grid.showHcenter) {
            let hLine = doc.createElementNS('http://www.w3.org/2000/svg','line');
            addAttrToEl(doc, hLine, 'x1', centerLines[0].vertical ? centerLines[0].position : 0);
            addAttrToEl(doc, hLine, 'x2', centerLines[0].vertical ? centerLines[0].position : grid.width);
            addAttrToEl(doc, hLine, 'y1', centerLines[0].vertical ? 0 : centerLines[0].position);
            addAttrToEl(doc, hLine, 'y2', centerLines[0].vertical ? grid.height : centerLines[0].position);
            addAttrToEl(doc, hLine, 'style', `stroke:${centerLines[0].color};stroke-opacity:${centerLines[0].opacity};stroke-width:1`); 
            centerGroup.appendChild(hLine);
        }

        if (grid.showVcenter) {
            let vLine = doc.createElementNS('http://www.w3.org/2000/svg','line');
            addAttrToEl(doc, vLine, 'x1', centerLines[1].vertical ? centerLines[1].position : 0);
            addAttrToEl(doc, vLine, 'x2', centerLines[1].vertical ? centerLines[1].position : grid.width);
            addAttrToEl(doc, vLine, 'y1', centerLines[1].vertical ? 0 : centerLines[1].position);
            addAttrToEl(doc, vLine, 'y2', centerLines[1].vertical ? grid.height : centerLines[1].position);
            addAttrToEl(doc, vLine, 'style', `stroke:${centerLines[1].color};stroke-opacity:${centerLines[1].opacity};stroke-width:1`); 
            centerGroup.appendChild(vLine);
        }

        svgGrid.appendChild(centerGroup);
    }

    let drawingLayer = doc.createElementNS('http://www.w3.org/2000/svg','g');
    addAttrToEl(doc, drawingLayer, 'id', 'Drawing');
    addAttrToEl(doc, drawingLayer, 'inkscape:label', 'Drawing');
    addAttrToEl(doc, drawingLayer, 'inkscape:groupmode', 'layer');

    svg.appendChild(svgGrid);
    svg.appendChild(drawingLayer);
    return svg;
}